import { Group, Text, UnstyledButton, Box } from '@mantine/core'
import { IconBook, IconUsers, IconChartBar } from '@tabler/icons-react'

const DEFAULT_TABS = [
  { key: 'story', label: 'STORY', icon: IconBook },
  { key: 'crew', label: 'CREW', icon: IconUsers },
  { key: 'status', label: 'STATUS', icon: IconChartBar },
]

export function GameTabBar({ activeTab, onTabChange, tabs = DEFAULT_TABS }) {
  return (
    <Box
      style={{
        borderBottom: '1px solid rgba(0, 255, 255, 0.1)',
        background: 'rgba(6, 14, 26, 0.8)',
      }}
    >
      <Group gap={0}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key
          return (
            <UnstyledButton
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              px="md"
              py={8}
              style={{
                borderBottom: isActive
                  ? '2px solid rgba(0, 229, 255, 0.8)'
                  : '2px solid transparent',
                transition: 'all 0.2s ease',
              }}
            >
              <Group gap={6}>
                <tab.icon
                  size={14}
                  color={isActive ? 'rgba(0, 229, 255, 0.9)' : 'rgba(255, 255, 255, 0.35)'}
                  style={{ transition: 'color 0.2s ease' }}
                />
                <Text
                  size="xs"
                  fw={600}
                  ff="Orbitron, sans-serif"
                  c={isActive ? 'cyan.3' : 'dimmed'}
                  style={{ transition: 'color 0.2s ease' }}
                >
                  {tab.label}
                </Text>
              </Group>
            </UnstyledButton>
          )
        })}
      </Group>
    </Box>
  )
}
